import React, { useEffect, useState } from 'react'
import { useTranslate } from '../../../components/TranslationText'
import SearchBox from '../../../components/SearchBox';
import { useLocation, useNavigate } from 'react-router';
import { aedLogoStyle, eFormButtonsContainer, getDirhamImage, iconContainer, noDataCard, showIconsContainer, termsTitle } from '../../../common/cssclasses';
import { convertToCamelCase } from '../../../helper/convertToCamelCase';
import SubmitServiceBtn from '../../../components/servicesButtons/SubmitServiceBtn';
import UserDropDown from '../../../components/showEntry/UserDropDown';
import Loader from '../../../components/Loader';
import { getAuctionEntryDetials, getAuctionEntryOwnerHorses, SubmitAuctionHorses } from '../apis/AuctionEntryApis';
import AuctionEntryHorseCard from '../../../components/AuctionEntry/AuctionEntryHorseCard';
import { toast, ToastContainer } from 'react-toastify';
import { isEmpty } from '../../../helper/validaiteInputs';


const BaseURL = process.env.REACT_APP_BASE_URL;

export default function AucitonEntryParticipate() {
    const currentLanguage = localStorage.getItem('eahsLang') ?? 'en';
    const ownerId = localStorage.getItem('currentSubAccountId') ?? '';
    const { translate } = useTranslate();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const auctionId = searchParams.has("auctionId")
        ? searchParams.get("auctionId")
        : "";
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState('draft');
    const [horseSearchValue, setHorseSearchValue] = useState('');
    const [maxAllowedHorses, setMaxAllowedHorses] = useState(10);
    const [auctionDetials, setAuctionDetails] = useState({});
    const [horsesList, setHorsesList] = useState([]);
    const [loaded, setLoaded] = useState(true);
    const [horsesLoaded, setHorsesLoaded] = useState(false);
    const [tabInitialized, setTabInitialized] = useState(false);
    const userProfile = JSON.parse(localStorage.getItem("eahsUserProfile"));
    const [profile, setProfile] = useState({
        label:
            !!userProfile &&
            userProfile?.ownerRegisterNo +
            " - " +
            userProfile[`fullName${currentLanguage === "en" ? "" : "Ar"}`],
        value: localStorage.getItem("EAHSUserID"),
    });



    const uniqueCategories = ['draft', ...Array.from(new Set(horsesList.filter((x) => x.status != "" && x.status?.toLowerCase() != "draft").map(horse => horse.status)))];
    const statusToCount = ['pendingpayment', 'rejected', 'completed', 'waitinglist'];

    //getAuctionDetails
    async function getAuctionDetails(auctionId) {
        const auctionDetails = await getAuctionEntryDetials(auctionId);
        setMaxAllowedHorses(auctionDetails?.maxHorsesPerOwner);
        setAuctionDetails(auctionDetails);
        setLoaded(true);

    }

    // getHorseList
    async function getHorseList(ownerId) {
        setHorsesLoaded(false);
        setTabInitialized(false);
        const horses = await getAuctionEntryOwnerHorses(ownerId, auctionId);
        setHorsesList(horses ?? []);
        setHorsesLoaded(true);
        setLoaded(true);
    }


    function addRemoveHorse(id, isRemovingCall = false) {
        const maxReached = (horsesList.filter((x) => x.isSelected == true || statusToCount.includes(x.status)).length >= maxAllowedHorses) && (maxAllowedHorses > 0);
        if (maxReached && !isRemovingCall) {
            toast.error(translate('web.maxHorsesReached', 'you Have Reached The maximum Horses to add'));
            return;
        }
        setHorsesList((prev) => {
            return prev.map(horse =>
                horse.id === id ? { ...horse, isSelected: !horse.isSelected } : horse
            );
        });
    }


    useEffect(() => {
        getAuctionDetails(auctionId)
        getHorseList(ownerId);
    }, [])

    // controlers


    const horseCardContainer = 'col-xl-9 col-lg-8 col-md-6  col-sm-12 col-12';
    const horseCard = 'col-md-4 col-sm-6 col-12';
    const displayedHorses = horsesList.filter(item => horseSearchValue.toLowerCase() === '' || item.name.toLowerCase().includes(horseSearchValue.toLowerCase()) || item.regNr.toLowerCase().includes(horseSearchValue.toLowerCase()));



    function submitHorses() {
        SubmitAuctionHorses(auctionId).then((res) => {
            if (res == true) {
                navigate(`/auctionEntryCheckout?auctionId=${auctionId}`)
            } else {
                toast.error('web.unExpectedError');
            }
        })
    }
    useEffect(() => {
        debugger;
        if (!tabInitialized && uniqueCategories.length > 1) {
            setActiveTab(uniqueCategories[1]);
            setTabInitialized(true);
        }
    }, [uniqueCategories, tabInitialized]);

    if (!loaded) {
        return (
            <Loader />
        )
    }


    function updateHorseInArray(horseId, auctionHorseId, isDelete = false, isWatingList = false) {
        if (isDelete) {
            return;
        } else {
            if (isWatingList) {
                setHorsesList(prevList =>
                    prevList.map(horse =>
                        horse.id == horseId
                            ? { ...horse, auctionHorseId, status: 'WaitingList', isSelected: true }
                            : horse
                    )
                );
                setActiveTab('WaitingList')
            } else {
                setHorsesList(prevList =>
                    prevList.map(horse =>
                        horse.id == horseId
                            ? { ...horse, auctionHorseId, status: 'PendingPayment', isSelected: true }
                            : horse
                    )
                );
                setActiveTab('PendingPayment')
            }
        }
    }




    return (
        <>
            <ToastContainer
                position="top-right"
                closeOnClick
                theme="colored"
                autoClose={5000}
            />
            <div className='row'>
                <h2 className={termsTitle + " d-flex align-items-center flex-wrap"}>
                    {auctionDetials?.name}
                </h2>

                <div className={showIconsContainer}>
                    <div className={iconContainer}>
                        <img src={getDirhamImage(currentLanguage)} alt='AED' style={aedLogoStyle} />
                        <span>{`${translate("web.horseFees", "Horse Fees")} ${auctionDetials?.horseFees?.toLocaleString('en-US')} ${translate('web.aed', 'AED')}`}</span>
                    </div>
                    <div className={iconContainer}>
                        <i className=" fa-solid fa-chess-knight C89C66" />
                        <span>{`${auctionDetials?.maxHorsesPerOwner} ${translate("web.horsesmax", `horses max`)} `}</span>
                    </div>
                    <div className={iconContainer}>
                        <i className=" fa-solid fa-chess-knight C89C66" />
                        <span>
                            {translate('web.selectedHorses', 'Selected Horses')}
                            <span dir="ltr" className="mx-1">{`(${horsesList?.filter((x) => x.isSelected == true || statusToCount.includes(x.status)).length} / ${maxAllowedHorses})`}</span>
                        </span>
                    </div>

                </div>
                {/* horse List */}
                <div className='col-xl-3 col-lg-4 col-md-6  col-sm-12 col-12' style={{ maxHeight: '60vh', overflowY: 'auto', minHeight: 400 }}>
                    <SearchBox placeholder={translate('web.search', 'search')} value={horseSearchValue} onChange={(e) => setHorseSearchValue(e.target.value)} isPadding isFullWidth={true} />
                    <UserDropDown key={'userDropDown'} profile={profile} setProfile={setProfile} onChange={(getHorseList)} />
                    <br />
                    {horsesLoaded ? <>
                        {displayedHorses?.map((horse, index) => (
                            <AuctionEntryHorseCard toast={toast} showDetails={auctionDetials} key={`horse${horse.id} and ${horse?.auctionHorseId}`} getHorseList={getHorseList} updateHorseInArray={updateHorseInArray} auctionId={auctionId} horse={horse} onClick={() => { addRemoveHorse(horse.id); setActiveTab('draft') }} />
                        ))}
                    </> : <Loader />
                    }
                </div>
                {/* Horse Tabs */}
                {horsesLoaded ?

                    <div className={horseCardContainer}>
                        <div className="row  second_section_bar " style={{ cursor: 'pointer', justifyContent: 'flex-start' }}>
                            {uniqueCategories.map((item, index) => (
                                <>
                                    <div
                                        className={"col-lg-2 col-md-4 col-sm-6 col-8 my-2 text-center px-0"} style={{ minWidth: 250 }}
                                        onClick={() => setActiveTab(item)}
                                    >

                                        <span className={`${activeTab == item ? 'fw-bold' : ''} capatalize_text`} style={{ fontSize: 14 }}>{translate(`web.${convertToCamelCase(item)}`, convertToCamelCase(item))}</span>

                                        <div className="service_bar_underline" style={activeTab == item ? { border: '3px solid var(--mainGold)', marginTop: 16 } : {}}></div>
                                    </div>
                                </>
                            ))}
                        </div>
                        {horsesList.filter((x) => x.isSelected == true && (x.status.toLowerCase() == activeTab || x.status == "")).length > 0 && activeTab == 'draft' &&
                            <div className='row ' >

                                {horsesList.filter((x) => x.isSelected == true && (x.status.toLowerCase() == activeTab || x.status == "")).map((horse, index) => (
                                    <div className={horseCard}>
                                        <AuctionEntryHorseCard toast={toast} key={`horse${horse.id} and ${horse?.auctionHorseId}`} getHorseList={getHorseList} updateHorseInArray={updateHorseInArray} showDetails={auctionDetials} auctionId={auctionId} horse={horse} onClick={() => addRemoveHorse(horse.id, true)} isSelectedTab={true} />
                                    </div>

                                ))}
                            </div>
                        }
                        {horsesList.filter((x) => x.isSelected == true && (x.status.toLowerCase() == activeTab || x.status == "")).length == 0 && activeTab == 'draft' &&
                            <div className='row mx-0 mb-main'>
                                <div className={noDataCard}>
                                    <span className='red fw-bold'>
                                        {translate('web.noDraft', 'No Draft')}
                                    </span>
                                </div>
                            </div>
                        }
                        {horsesList.filter((x) => x.status == activeTab && x.status != 'draft').length > 0 &&
                            <div className='row ' >
                                {horsesList.filter((x) => x.status == activeTab && x.status != 'draft').map((horse, index) => (
                                    <div className={horseCard}>
                                        <AuctionEntryHorseCard toast={toast} key={`horse${horse.id} and ${horse?.auctionHorseId}`} getHorseList={getHorseList} updateHorseInArray={updateHorseInArray} showDetails={auctionDetials} auctionId={auctionId} horse={horse} onClick={() => addRemoveHorse(horse.id)} isSelectedTab={true} />
                                    </div>
                                ))}
                            </div>
                        }
                        {horsesList.filter((x) => (x.status?.toLowerCase() == 'draft' || x.status?.toLowerCase() == 'pendingpayment')).length > 0 &&
                            <div className={eFormButtonsContainer}>
                                <SubmitServiceBtn onClick={() => (submitHorses())} />
                            </div>
                        }
                    </div>
                    : <Loader />}
            </div >
        </>
    )
}
